import { render, staticRenderFns } from "./BaseAlert.vue?vue&type=template&id=fdbd62e0&scoped=true&"
import script from "./BaseAlert.vue?vue&type=script&lang=js&"
export * from "./BaseAlert.vue?vue&type=script&lang=js&"
import style0 from "./BaseAlert.vue?vue&type=style&index=0&id=fdbd62e0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdbd62e0",
  null
  
)

export default component.exports